export type LiveStatus = "online" | "offline" | "testing";

export type MCPDisplayStatus = LiveStatus | "disabled" | "needsAttention";

type MCPStatusInput = {
  isActive: boolean;
  needsAttention: boolean;
  authRequired: boolean;
  liveStatus: LiveStatus;
};

type MCPStatusState = {
  status: MCPDisplayStatus;
  showReauthentication: boolean;
};

export const getMCPStatusState = ({
  isActive,
  needsAttention,
  authRequired,
  liveStatus,
}: MCPStatusInput): MCPStatusState => ({
  status: !isActive
    ? "disabled"
    : needsAttention || authRequired
      ? "needsAttention"
      : liveStatus,
  // A server warning can mean more than an expired OAuth session. Keep the
  // reconnect action tied only to the connection test's explicit auth signal.
  showReauthentication: authRequired,
});
